import isDev from './isDev';
import isStaging from './isStaging';

type callbackType = () => any;

export function runCallbackBasedOnCurrentEnvironment(
  developCallback: callbackType,
  stagingCallback: callbackType,
  productionCallback: callbackType,
): any {
  if (isDev()) {
    return developCallback && developCallback();
  } else if (isStaging()) {
    return stagingCallback && stagingCallback();
  } else {
    return productionCallback && productionCallback();
  }
}
